<template>
  <div class="animate__animated animate__fadeIn">
    <h4>Nova atividade</h4>
    <b-alert v-if="erro" show variant="danger">{{ erro }}</b-alert>
    <form @submit.prevent="submit">
      <div class="row">
        <form-input v-model="form.atividade" label="Atividade:" required />
        <form-input v-model="form.frequencia" label="Frequência:" grid="6" required />
        <form-input v-model="form.local" label="Local da atividade:" grid="6" required />
        <form-input v-model="form.objetivo" label="Objetivo:" required />
        <form-input v-model="form.data_atividade" label="Data:" grid="6" type="date" required />
        <form-input v-model="form.hora_atividade" label="Hora:" grid="6" type="time" required />
      </div>
      <p class="text-muted">A atividade será cadastrada com o status Aberto.</p>
      <div class="d-flex justify-content-end">
        <b-button type="button" variant="secondary" size="sm" class="mr-2"
          :disabled="salvando" @click="$emit('voltar')">Voltar</b-button>
        <b-button type="submit" variant="success" size="sm" :disabled="salvando">
          {{ salvando ? 'Salvando...' : 'Salvar atividade' }}
        </b-button>
      </div>
    </form>
  </div>
</template>

<script>
import { API, dataApi, horaApi, mensagemErro, notificar } from './apoioAtividadesCrianca';

export default {
  props: { item: { type: Object, required: true } },
  data() {
    return {
      salvando: false,
      erro: '',
      form: { atividade: '', frequencia: '', local: '', objetivo: '',
        data_atividade: '', hora_atividade: '' },
    };
  },
  methods: {
    async submit() {
      if (this.salvando) return;
      this.erro = '';
      if (!this.item.id) {
        this.erro = 'Não foi possível identificar o acolhimento.';
        return;
      }
      if (Object.keys(this.form).some(campo => !String(this.form[campo] || '').trim())) {
        this.erro = 'Preencha todos os campos obrigatórios.';
        return;
      }
      this.salvando = true;
      try {
        const response = await axios.post(`${API}/store`, {
          ...this.form,
          acolhimento_id: this.item.id,
          data_atividade: dataApi(this.form.data_atividade),
          hora_atividade: horaApi(this.form.hora_atividade),
        });
        notificar(this, 'success', 'Atividade cadastrada com sucesso!');
        // Abre a edição dentro da aba de atividades, sem recarregar o acolhimento.
        this.$emit('atividadeCriada', response.data.atividade);
      } catch (erro) {
        this.erro = mensagemErro(erro, 'Erro ao cadastrar a atividade.');
        notificar(this, 'warning', this.erro);
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>
